import ChatFilterOptions from 'conversations-internal-schema/constants/ChatFilterOptions';
import http from 'conversations-http/clients/http';
const {
  ENDED
} = ChatFilterOptions;
export const closeThread = ({
  threadId
}) => {
  const url = `conversations-threads/v1/threads/${threadId}/status`;
  return http.put(url, {
    data: {
      status: ENDED
    }
  });
};